<template>
  <header
    v-if='kirby'
    class='top'>
    <nav
      v-if='kirby.pages'
      class='home'>
      <router-link
        v-if='kirby.pages.home'
        :to='{ path : "/" }'>
        <svg
          id='Layer_1'
          version='1.1'
          xmlns='http://www.w3.org/2000/svg'
          xmlns:xlink='http://www.w3.org/1999/xlink'
          x='0px'
          y='0px'
          viewBox='0 0 109.83 7.35'
          style='enable-background:new 0 0 109.83 7.35;'
          xml:space='preserve'>
          <path
            d='M0,0h4.37c1.72,0,2.96,0.39,2.96,2.17c0,1.34-0.96,2.08-2.03,2.14l2.23,2.96H5.78L3.67,4.41H1.42v2.86H0V0z M4.16,3.23
          c1.16,0,1.75-0.17,1.75-1.03c0-0.85-0.59-1.02-1.75-1.02H1.42v2.05H4.16z' />
          <path
            d='M14.29,0h1.62l3.53,7.27h-1.5L17.18,5.6h-4.19l-0.77,1.67h-1.51L14.29,0z M16.62,4.38L15.1,1.14l-1.52,3.24H16.62z' />
          <path
            d='M23.07,0h1.42v7.27h-1.42V0z' />
          <path
            d='M28.65,5.86c0.51,0.13,1,0.23,1.63,0.23c1.67,0.01,2-0.59,1.98-1.66V0h1.42v4.51c-0.02,2.14-1.09,2.84-3.23,2.84
          c-0.68,0-1.45-0.07-1.8-0.16V5.86z' />
          <path
            d='M41.02,0h1.62l3.53,7.27h-1.5L43.91,5.6h-4.19l-0.77,1.67h-1.51L41.02,0z M43.35,4.38l-1.52-3.24l-1.52,3.24H43.35z' />
          <path
            d='M57.16,1.76h-0.02v5.51h-1.26V0h1.91l2.27,5.39L62.37,0h1.87v7.27h-1.26V1.76h-0.02l-2.33,5.51H59.5L57.16,1.76z' />
          <path
            d='M71.32,0h1.62l3.53,7.27h-1.5L74.21,5.6h-4.19l-0.77,1.67h-1.51L71.32,0z M73.65,4.38l-1.52-3.24l-1.52,3.24H73.65z' />
          <path
            d='M80.01,0h1.42v6.01h5.27v1.26h-6.69V0z' />
          <path
            d='M90.39,0h1.42v3.39L95.84,0h2.02l-3.47,2.88l3.82,4.39h-1.86l-2.99-3.55l-1.55,1.29v2.26h-1.42V0z' />
          <path
            d='M104.68,0h1.62l3.53,7.27h-1.5l-0.76-1.67h-4.19l-0.77,1.67h-1.51L104.68,0z M107.01,4.38l-1.52-3.24l-1.52,3.24H107.01z' />
        </svg>
      </router-link>
    </nav>
    <nav class='listed'>
      <span
        v-for='page in kirby.pages'
        :key='page.id'>
        <router-link
          v-if='page.visible'
          :class='"listed pages "+(kirby.page.uid === page.uid ? "active" : "")'
          :to='{ path : "/" + page.uid }'
          :title='page.strings.title'>
          <span>{{ page.strings.title }}</span>
        </router-link>
      </span>
    </nav>
  </header>
</template>

<script>
module.exports = {
  computed: {
    kirby () {
      if(this.$store) return this.$store.state.kirby
    }
  }
}
</script>

<style scoped>

  header.top {
    transition: all 0.125s ease-in;
    padding: 3.5rem 0 3rem;
    font-size: 1rem;
    line-height: 100%;
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 2;
    transform: translateY(0);
    opacity: 1;
  }

  header.hide {
    transform: translateY(-0.5rem);
    opacity: 0;
  }

  nav {
    display: inline;
    position: relative;
    left: 1.25rem;
  }

  nav.home svg {
    width: 9.5rem;
    height: 1em;
  }

  nav.home a {
    text-transform: uppercase;
    font-family: sans-serif;;
    font-size: 0.85rem;
    line-height: 0.8rem;
    vertical-align: bottom;
    letter-spacing: 0.35em;
    margin-right: 0.5rem;
  }

  nav.home a:active {
    opacity: 0.5;
  }

  nav.home a:active::after {
    opacity: 1;
  }

  nav.home a::after {
    content: '|';
    font-weight: lighter;
    font-size: 0.825rem;
    margin-left: 2.5rem;
    margin-right: 1.5rem;
    position: relative;
    top: -0.05em;
  }

  nav.listed {
    font-weight: lighter;
  }

  nav.listed a:active {
    opacity: 0.5;
  }

  nav a {
    position: relative;
    margin: 0 2.25rem 0 0;
  }

  nav a::before {
    top: .17em;
    left: 0;
    position: absolute;
    content: attr(title);
    font-style: italic;
    display: block;
    white-space:nowrap;
    opacity: 0;
  }

  nav a.active span, nav a:hover span {
    opacity: 0;
  }

  nav a.active::before, nav a:hover::before {
    opacity: 1;
  }

  @media only screen and (max-aspect-ratio: 4/5) and (max-width: 700px) {
    header {
      text-align: left !important;
      margin: 0 1rem;
    }

    nav.home {
      margin: 0 1.25rem 0 0;
    }

    nav.home a::after {
      display: none !important;
    }

    nav.listed a {
      margin: 0 1.25rem 0 0;
    }
  }
</style>
